<template>
    <div id="addConsignment">
        <a-modal v-model="visible" :title="labelName" :maskClosable="false">
            <template slot="footer">
                <a-button size="small" type="primary" @click="save">Save</a-button>
            </template>
            <a-form :form="form">
                <a-form-item :label="labelName"  v-bind="formItemLayout">
                    <a-input
                        size="small"
                        v-decorator="['fromValue', { rules: [{ required: true}] }]"
                    />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data(){
            return{
                labelName: '',
                ajaxtype: '',
                uids: [],
                visible: false,
                form:this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
            }
        },
        methods:{
            show(name,type,uids){
                this.uids = uids
                this.labelName = name
                this.visible = true
                this.ajaxtype = type
                this.form.resetFields();
            },
            save(){
                this.form.validateFields((error, values)=>{
                    if(!error){
                       let params = {}
                       let ajaxTypeName = ''
                       if(this.ajaxtype == 'createPallet'){
                           ajaxTypeName = api.CFSADDPALLET
                           params = {
                               "cfsOrderDetailUids": this.uids,
                               "palletNo": values.fromValue
                           }
                       }else if(this.ajaxtype == 'createShipment'){
                           ajaxTypeName = api.CFSADDORDERSHIPMENT
                           params = {
                               "nawb": values.fromValue,
                               "uids": this.uids,
                           }
                       }else if(this.ajaxtype == 'orderHeader'){
                            ajaxTypeName = api.CFSADDORDERHEADERSHIPMENT
                             params = {
                               "nawb": values.fromValue,
                               "uids": this.uids,
                           }
                       }else  if(this.ajaxtype == 'pallet'){
                           ajaxTypeName = api.CESADDPALLETSHIPMENT
                           params = {
                               "nawb": values.fromValue,
                               "uids": this.uids,
                           }
                       }else if(this.ajaxtype == 'BatchUpdateMAWB'){
                           ajaxTypeName = api.CFSBATCHUPDATESHIPMENTMAWB
                           params = {
                               "nawb": values.fromValue,
                               "uids": this.uids,
                           }
                       }
                       ajax.post(ajaxTypeName,params).then(res=>{
                           if(res.code == 200){
                               this.$message.success(res.msg)
                               this.visible = false
                               this.$emit('cancelImport','init')
                           }else{
                               this.$customMessage.warning(res.msg)
                           }
                       })
                    }
                })
            }
        }
    }
</script>